import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false
import router from './router'
import store from './store'

import appConfig from '@/config/app.js'
import Axios from '@/plugins/Axios'
import msg from '@/plugins/msg'

import '@/assets/scss/main.scss'
import '@/assets/scss/theme.scss'
import '@/assets/scss/icon_park.scss'
//引入remixiicon
import '@/assets/icon/remixicon/remixicon.css'

import ElementUI from 'element-ui';

//自定义公共组件
import LTable from '@/components/table';
import { AuthButton, AuthSwitch, AuthIcon, Auth, AuthTextButton } from '@/components/auth';
import LPage from '@/components/page';
import Dialog from '@/components/dialog';
import LDivider from '@/components/divider';
import { UploadImg, Upload } from '@/components/upload';
import { TextButton } from '@/components/button';
import { DateRange } from '@/components/date';
import echarts from 'echarts'
import storeConfig from '@/utils/store'
// import './registerServiceWorker'

// import VueSocketIO from 'vue-socket.io'

// Vue.use(new VueSocketIO({
//     debug: true,
//     connection: "ws://"+appConfig.websocket_url,
//     options: { transports: ["websocket"],autoConnect: false } //Optional options
// }))


Vue.config.productionTip = false;
if(storeConfig.get("BASE_URL")&&storeConfig.get("UPLOAD_URL")){
  appConfig.api.base_url=storeConfig.get("BASE_URL");
  appConfig.upload_url=storeConfig.get("UPLOAD_URL");
}
//注册配置信息到全局
Vue.$_config = appConfig;
Vue.prototype.$_config = appConfig;
Vue.prototype.$echarts = echarts //挂载到Vue实例上面

//注册ajax请求方法
Vue.use(Axios);

//注册快捷消息提示
Vue.use(msg);

//注册element ui到全局
Vue.use(ElementUI);
//注册公共表格到全局
Vue.component(LTable.name, LTable);
//注册权限控制组件到全局
Vue.component(AuthButton.name, AuthButton);
Vue.component(AuthSwitch.name, AuthSwitch);
Vue.component(AuthIcon.name, AuthIcon);
Vue.component(Auth.name, Auth);
Vue.component(AuthTextButton.name, AuthTextButton);
//注册全局弹窗
Vue.component(Dialog.name, Dialog);
//注册分页公共组件到全局
Vue.component(LPage.name, LPage);
//注册分割线
Vue.component(LDivider.name, LDivider);
//注册上传组件
Vue.component(Upload.name, Upload);
//注册上传图片组件
Vue.component(UploadImg.name, UploadImg);
//注册文字按钮
Vue.component(TextButton.name, TextButton);
//注册通用日期范围选择组件
Vue.component(DateRange.name, DateRange);

// import BaiduMap from 'vue-baidu-map'
// Vue.use(BaiduMap, {
//   ak: ''  //  在此输入你自己的百度地图ak
// })

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
